export var rowStyle = {
  backgroundColor: '#EBFAF8'
};
export var subComponentStyle = {
  'max-height': '35rem'
};
export var DEFAULT_RESULTS_PER_PAGE = 50;
export var DEFAULT_RESULTS_PER_PAGE_OPTIONS = [50, 100, 150, 200];